module.exports = "<h1>{{heading}}</h1>";